import { createIntl } from "react-intl";
import flatten from "flat";
import { plMessages } from "./translations/pl";

export const intl = createIntl({ locale: "pl-PL", messages: flatten(plMessages) });

export const t = (trKey: string, values?: any) => intl.formatMessage({ id: trKey }, values);

export const tExists = (trKey: string) => !!intl.messages[trKey];
